module.exports = __webpack_public_path__ + "img/candidate2.3362c10d.png";